'use strict';

const $ = require('jquery');

$(document).ready(function() {
    /**
     * Make Header area Height of img
     */
    let headerAreaHeight = function() {
        let scope = document.querySelectorAll('.slider_wrapper[data-slider-config="headerBig"]');
        let headerheight = document.querySelector('.main-header').offsetHeight;
        let $windowHeight = $(window).height();
        let areaHeight = $windowHeight - headerheight + 'px';

        for (let i = 0; scope.length > i; i++) {
            let scopeItem = scope[i];
            let sliderItems = scopeItem.querySelectorAll('img, iframe');
            let slickTrack = scopeItem.querySelector('.slick-track');

            scopeItem.style.height = areaHeight;
            slickTrack.style.height = areaHeight;

            for (let j = 0; sliderItems.length > j; j++) {
                let sliderItem = sliderItems[j];
                sliderItem.style.height = areaHeight;
            }
        }
    };

    /**
     * Put padding top to body
     */
    let bodyPadding = function() {
        let headerheight = document.querySelector('.main-header').offsetHeight;

        $('.main-wrapper').css('padding-top', headerheight + 'px');
    };

    headerAreaHeight();
    bodyPadding();
    $(window).resize(function() {
        headerAreaHeight();
    });
});

